// tslint:disable: max-line-length triple-equals
import moment from 'moment';
import { getComparedToAverageClassStyle } from '../../helpers/getComparedToAverageStyle';
import { StandardFilterType } from '../../enums/StandardFilterType';
import { getStandardTypeFilterValue } from '../../enums/labels/getStandardTypeFilterValue';
import { CreateDataByIndexedDB, GetAllDataByIndexedDB } from '../../indexed/index';
import axiosInstance from '../../helpers/interceptor';
import { userHotelDetails } from '../../helpers/handleBrandAndHotelData';

export const topBottom = async (selectedAssessment) => {
    const { selectedHotel, selectedBrand} = userHotelDetails();

    let dataD: any = [];
    const OfflineData = await GetAllDataByIndexedDB(`${Env.API_URL}/customer/hotel-benchmarking/${selectedHotel}/top-bottom-departments?&standard=LQA&hotelTypes=City&hotelTypes=Resort&brandId=${selectedBrand}&toDate=${selectedAssessment}&isClientApp=true`, selectedHotel);
    if (OfflineData) {
        dataD = OfflineData;
    } else {
        const { data } = await axiosInstance.get(`${Env.API_URL}/customer/hotel-benchmarking/${selectedHotel}/top-bottom-departments?&standard=LQA&hotelTypes=City&hotelTypes=Resort&brandId=${selectedBrand}&toDate=${selectedAssessment}&isClientApp=true`);
        dataD = data;
        CreateDataByIndexedDB(`${Env.API_URL}/customer/hotel-benchmarking/${selectedHotel}/top-bottom-departments?&standard=LQA&hotelTypes=City&hotelTypes=Resort&brandId=${selectedBrand}&toDate=${selectedAssessment}&isClientApp=true`, data, selectedHotel);
    }

    return dataD;
};

export const getCategory = async (standard) => {
    const { selectedHotel } = userHotelDetails();
    let dataD: any = [];
    const OfflineData = await GetAllDataByIndexedDB(`${Env.API_URL}/customer/hotel-reports-filter/${selectedHotel}/category?&standard=${standard && standard != StandardFilterType.LQA ? getStandardTypeFilterValue(standard) : StandardFilterType.LQA}&view=category`, selectedHotel);
    if (OfflineData) {
        dataD = OfflineData;
    } else {
        const { data } = await axiosInstance.get(`${Env.API_URL}/customer/hotel-reports-filter/${selectedHotel}/category?&standard=${standard && standard != StandardFilterType.LQA ? getStandardTypeFilterValue(standard) : StandardFilterType.LQA}&view=category`);
        dataD = data;
        CreateDataByIndexedDB(`${Env.API_URL}/customer/hotel-reports-filter/${selectedHotel}/category?&standard=${standard && standard != StandardFilterType.LQA ? getStandardTypeFilterValue(standard) : StandardFilterType.LQA}&view=category`, data, selectedHotel);
    }

    return dataD;

};

export const getTrendScore = async (standard, selectedCompset, categoryId?: string, performanceClassification?: string) => {
    const { selectedHotel, selectedBrand} = userHotelDetails();
    if (standard !== 'LQA') {
        standard = 'custom' + standard ;
    }

    let view = `view=category`;
    let category = '';
    let compSet = '';

    if (performanceClassification && performanceClassification != 'all') {
        view = `view=performance`;
    }

    if (categoryId && categoryId != 'all') {
        category = `categoryId=${categoryId}`;
    }

    if (selectedCompset !== '0') {
        compSet = `&compSetNumber=${selectedCompset}`;
    }
    let dataD: any = [];
    const OfflineData = await GetAllDataByIndexedDB(`${Env.API_URL}/customer/hotel-trends/${selectedHotel}?brandId=${selectedBrand}&&standard=${standard}&${category}&${view}${compSet}&isClientApp=true`, selectedHotel);
    if (OfflineData) {
        dataD = OfflineData;
    } else {
        const { data } = await axiosInstance.get(`${Env.API_URL}/customer/hotel-trends/${selectedHotel}?brandId=${selectedBrand}&&standard=${standard}&${category}&${view}${compSet}&isClientApp=true`);
        dataD = data;
        CreateDataByIndexedDB(`${Env.API_URL}/customer/hotel-trends/${selectedHotel}?brandId=${selectedBrand}&&standard=${standard}&${category}&${view}${compSet}&isClientApp=true`, data, selectedHotel);
    }

    const theTrendData: any[] = [];

    dataD.map(d => {
        if (d && d.name != 'Emotional Intelligence') {
            const { scores, average, totalCompetitors } = d;
            const trends = scores.map(score => {
                return {
                    name: moment(score.assessmentDate).format('DD/MMM/YY'),
                    val: score.score,
                    lineVal: score.rank,
                    total: totalCompetitors,
                    intent: getComparedToAverageClassStyle((score.score) - average),
                };
            });
            theTrendData.push({...d, scores: trends});
        }
    });
    return performanceClassification && performanceClassification != 'all' ? theTrendData.filter(d => d.name == performanceClassification) : theTrendData;
};
